import React from "react"

import "./layout.css"
import "bootstrap/dist/css/bootstrap.min.css"
import Navbar from "../shared/Navbar"
import Footer from "../shared/Footer"

const Layout = ({ children }) => {

  return (
    <>
      <Navbar />
      <main>{children}</main>
      <Footer />
    </>
  )
}


export default Layout
